import React from 'react';
import { Button } from './ui/button';

const InvestmentCTA = () => {
  return (
    <section className="py-12 bg-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h3 className="text-[#1a3a5c] text-xl md:text-2xl font-bold mb-4">
          Start your U.S. journey with a minimum investment of $500,000 through government-approved Regional Centers.
        </h3>
        <p className="text-gray-600 mb-6">
          These centers manage your investment while ensuring compliance with the visa program's job creation requirements, allowing you to focus on building your future in the U.S.
        </p>
        <Button
          onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-[#c94a4a] hover:bg-[#b33d3d] text-white px-8 py-3 rounded font-medium"
        >
          Invest Now
        </Button>
      </div>
    </section>
  );
};

export default InvestmentCTA;
